// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const BulletList_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M7.125 6A1.125 1.125 0 0 1 8.25 4.875h12a1.125 1.125 0 0 1 0 2.25h-12A1.125 1.125 0 0 1 7.125 6Zm13.125 4.875h-12a1.125 1.125 0 0 0 0 2.25h12a1.125 1.125 0 0 0 0-2.25Zm0 6h-12a1.125 1.125 0 0 0 0 2.25h12a1.125 1.125 0 0 0 0-2.25ZM4.125 10.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm0-6a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm0 12a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Z',
  viewBox: '0 0 24 24',
  glyph: 'BulletList_Filled_Corner0_Rounded',
})

export const BulletList_Stroke1_Corner0_Rounded = createSinglePathSVG({
  path: 'M7.5 6a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 6Zm12.75 5.25h-12a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5Zm0 6h-12a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5ZM4.125 4.875A1.125 1.125 0 1 0 5.25 6a1.125 1.125 0 0 0-1.125-1.125Zm0 6A1.125 1.125 0 1 0 5.25 12a1.125 1.125 0 0 0-1.125-1.125Zm0 6A1.125 1.125 0 1 0 5.25 18a1.125 1.125 0 0 0-1.125-1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'BulletList_Stroke1_Corner0_Rounded',
})

export const BulletList_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M7.5 6a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 6Zm12.75 5.25h-12a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5Zm0 6h-12a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5ZM4.125 4.875A1.125 1.125 0 1 0 5.25 6a1.125 1.125 0 0 0-1.125-1.125Zm0 6A1.125 1.125 0 1 0 5.25 12a1.125 1.125 0 0 0-1.125-1.125Zm0 6A1.125 1.125 0 1 0 5.25 18a1.125 1.125 0 0 0-1.125-1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'BulletList_Stroke2_Corner0_Rounded',
})
